module.exports = __webpack_public_path__ + "img/train-stop.38feeafb.png";